export default "__VITE_ASSET__ClQ6JpYm__"